import React from "react";
import { Link } from "react-router-dom";
import { classNames } from "../../helpers/classNames";

const Button = ({
  buttonEffect = "",
  buttonClasses,
  buttonType = "button",
  buttonIcon,
  buttonIconPosition = "left",
  buttonLabel,
  buttonLabelClasses,
  buttonFunction = () => {},
  buttonHasLink,
  buttonLink,
  isDisable = false,
  loading = false,
  target,
  ...props
}) => {
  return (
    <>
      {buttonHasLink ? (
        <Link
          to={buttonLink}
          {...(target && { target })}
          className={classNames(
            "font-Inter relative overflow-hidden flex justify-center items-center gap-2 bg-primary text-white rounded-2xl text-base h-10 py-0 px-3 transition-all duration-200 hover:bg-emeraldPrimary border border-primaryBorder font-semibold",
            buttonClasses,
            isDisable ? "pointer-events-none opacity-75" : ""
          )}
          onClick={buttonFunction}
        >
          {buttonIconPosition === "left" && (loading || buttonIcon) && (
            <i
              className={classNames(
                "fa-fw",
                loading
                  ? "fa-duotone fa-solid fa-spinner-third animate-spin"
                  : buttonIcon
              )}
            ></i>
          )}
          {buttonLabel && (
            <span className={classNames("text-base", buttonLabelClasses)}>
              {buttonLabel}
            </span>
          )}
          {buttonIconPosition === "right" && (loading || buttonIcon) && (
            <i
              className={classNames(
                "fa-fw",
                loading
                  ? "fa-duotone fa-solid fa-spinner-third animate-spin"
                  : buttonIcon
              )}
            ></i>
          )}
        </Link>
      ) : (
        <button
          type={buttonType}
          className={classNames(
            "font-Inter relative overflow-hidden flex justify-center items-center gap-2 bg-primary text-white rounded-2xl text-base h-14 py-0 px-3 transition-all duration-200 hover:bg-emeraldPrimary border-2 border-primaryBorder font-semibold",
            buttonClasses,
            isDisable ? "pointer-events-none opacity-75" : ""
          )}
          style={{ textShadow: '0 1px 2px rgba(0, 0, 0, 0.4)' }}
          onClick={buttonFunction}
          disabled={isDisable}
        >
          {buttonIconPosition === "left" && (loading || buttonIcon) && (
            <i
              className={classNames(
                "fa-fw",
                loading
                  ? "fa-duotone fa-solid fa-spinner-third animate-spin"
                  : buttonIcon
              )}
            ></i>
          )}
          {buttonLabel && (
            <span className={classNames("text-base font-Inter", buttonLabelClasses)}>
              {buttonLabel}
            </span>
          )}
          {buttonIconPosition === "right" && (loading || buttonIcon) && (
            <i
              className={classNames(
                "fa-fw",
                loading
                  ? "fa-duotone fa-solid fa-spinner-third animate-spin"
                  : buttonIcon
              )}
            ></i>
          )}
        </button>
      )}
    </>
  );
};

export default Button;
